module.exports = __webpack_public_path__ + "static/media/home.8d300bc3.jpg";